import {Component, Input} from '@angular/core';

@Component({
  selector: 'form-item-text',
  standalone: true,
  imports: [],
  templateUrl: './form-item-text.component.html',
  styleUrl: './form-item-text.component.scss'
})
export class FormItemTextComponent {
    @Input({required: true }) subtitle!: string;
}
